
// eslint-disable-next-line import/prefer-default-export
export const mobile = 576;
export const tablet = 768;
export const desktop = 1024;
export const wide = 1412;
export const desktopHeight = 660;
